module.exports = fox._r("images/press/materials-icon-pr.png", __webpack_public_path__ + "_/common/images/press/materials-icon-pr.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/materials-icon-pr.png
// module id = 371
// module chunks = 2